import styled from "styled-components";

export const MedSubBtn = styled.button`
  width: 100%;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #2f65cb;
  background: #2f65cb0a;
  color: #2f65cb;
  font-size: 15px;
  font-weight: 500;
`;

export const OrderLabel = styled.p`
  margin-bottom: 2em;
  font-size: medium;
  color: var(--dark-light);
  font-weight: 400;

  span {
    font-weight: 600;
    font-size: x-large;
    color: var(--dark);
    margin: 0;
  }
`;

export const SubOrderLabel = styled.p`
  margin-bottom: 2em;
  font-size: medium;
  color: var(--dark-light);
  font-weight: 400;

  span {
    font-weight: 600;
    font-size: medium;
    color: var(--dark);
    margin: 0;
  }
`;

export const OrderWrapper = styled.div`
  text-align: center;
  display: flex;
  gap: 10px;
  justify-content: space-between;

  .inputWrap {
    width: 70%;

    input {
      width: 100%;
      background: transparent;
      height: 44px;
      border-radius: 4px;
      border: 1px solid #c4c4c4;
      box-shadow: none !important;
      font-size: 15px;
    }
  }

  .btnWrap {
    width: 30%;
    button {
      width: 100%;
      height: 44px;
      border-radius: 4px;
      border: 1px solid #2f65cb;
      background: transparent;
      color: #2f65cb;
      font-weight: 500;
      font-size: 15px;
    }
  }
`;

export const MedDetailsWrap = styled.div`
  border: 1px solid #2f65cb38;
  border-radius: 4px;
  margin-bottom: 1em;
  .medTitleWrap {
    background: #2f65cb0f;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    justify-content: center;
    display: flex;
    padding: 10px 10px;
    font-size: 12px;
    color: #333;

    .ant-checkbox-inner {
      width: 14px !important;
      height: 14px !important;
      background: #f8fbff !important;
      border-color: #2f65cb61 !important;
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: #2f65cb !important;
      width: 4px !important;
    }
  }
  .medTitle {
    font-size: 14px;
    color: #333;
  }

  .batchWrap {
    padding: 10px;
  }
  .batchDetailsWrap {
    display: flex;
    align-content: center;
    margin-bottom: 10px;
    font-size: 14px;
    gap: 5px;
    .name {
      width: 60%;
      vertical-align: middle;
      display: flex;
      align-items: center;
      text-align: left;
      word-break: break-word;
      line-height: 16px;
    }

    .qty,
    .editQty {
      width: 10%;
      vertical-align: middle;
      display: flex;
      align-items: center;
    }

    .editQty {
      width: 30%;
    }

    .qtyMissing {
      width: 30%;
      vertical-align: middle;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
  .batchDetailsWrap:last-child {
    margin-bottom: 0px;
  }
`;

export const BottomWrap = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  position: fixed;
  background: #2f65cb;
  bottom: 0px;
  left: 0;
  right: 0;
  z-index: 1;
  font-size: 15px;
  color: #fff;
  padding: 15px;
  max-width: 440px;
  justify-content: center;
  text-align: center;
  margin: auto;
  .left {
    width: 100%;
    text-align: center;
    border-right: 1px solid #f4f4f4;
  }

  .right {
    width: 100%;
    text-align: center;
  }
`;
